var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasolineUp1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 188,
    viewBox: "0 0 678 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.998 31.2V115.2H672.198L655.398 90H576.998L540.598 6H44.9982C16.9982 6 16.998 31.2 16.998 31.2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.199 6C224.199 6 448.199 6 492.999 6C537.799 6 543.399 11.6 546.199 17.2C548.999 22.8 571.399 87.2 579.799 87.2C588.199 87.2 599.399 87.2 635.799 87.2C672.199 87.2 672.199 112.4 672.199 112.4V115.2",
    stroke: "#F1E29E",
    strokeWidth: 11.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.199 90V170.853H672.199V114.207",
    stroke: "#F1E29E",
    strokeWidth: 11.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79883 182.4V76H353.424C365.474 76 400.599 107.856 425.799 107.856H515.399V182.4H5.79883Z",
    fill: "#F1E29E",
    stroke: "black",
    strokeWidth: 11.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 515.398,
    y: 98.4004,
    width: 156.8,
    height: 78.4,
    fill: "#F1E29E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.635 29.5236L534.199 28.4C531.635 29.5236 531.635 29.5236 531.635 29.5238L531.635 29.5246L531.636 29.5279L531.642 29.5414L531.666 29.5951L531.758 29.8066C531.84 29.9925 531.959 30.2666 532.113 30.6185C532.42 31.3225 532.862 32.3378 533.402 33.5827C534.482 36.0728 535.952 39.4795 537.514 43.1474C540.656 50.5215 544.12 58.8336 545.57 62.9335C546.768 66.3234 546.104 68.8229 544.864 70.4589C543.556 72.1856 541.424 73.2 539.298 73.2L445.141 73.2C439.518 73.2 436.429 71.3567 434.76 69.7704C433.897 68.9501 433.354 68.141 433.034 67.561C432.875 67.2715 432.773 67.0425 432.716 66.9032C432.688 66.8338 432.671 66.7873 432.664 66.7677C432.664 66.7671 432.663 66.7665 432.663 66.766L432.617 66.6135L432.539 66.442L429.99 67.6C432.539 66.442 432.539 66.4419 432.539 66.4417L432.539 66.4408L432.537 66.437L432.53 66.4219L432.503 66.362L432.397 66.1272L431.99 65.2301C431.638 64.4544 431.133 63.3397 430.521 61.9845C429.296 59.2739 427.641 55.6021 425.92 51.7561C422.454 44.0133 418.785 35.7084 417.754 33.0029C416.368 29.3659 419.092 22.8 427.02 22.8H519.347C524.55 22.8 527.582 24.6106 529.308 26.2375C530.197 27.0753 530.782 27.9064 531.137 28.5092C531.314 28.8096 531.432 29.0491 531.499 29.198C531.533 29.2722 531.554 29.3233 531.564 29.3473C531.565 29.3506 531.566 29.3535 531.567 29.3557L531.594 29.4299L531.635 29.5236Z",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.998 115.2V31.2C16.998 31.2 16.9982 6 44.9982 6C72.9982 6 294.198 6 338.998 6C383.798 6 389.398 11.6 392.198 17.2C394.998 22.8 417.398 87.2 425.798 87.2C434.198 87.2 445.398 87.2 481.798 87.2C518.198 87.2 518.198 112.4 518.198 112.4",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.998 115.2V31.2C16.998 31.2 16.9982 6 44.9982 6C60.9768 6 139.872 6 212.998 6",
    stroke: "#F1E29E",
    strokeWidth: 11.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165.4,
    y: 22.8,
    width: 50.4,
    height: 50.4,
    rx: 8.4,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5988,
    y: 22.8,
    width: 50.4,
    height: 50.4,
    rx: 8.4,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 229.798,
    y: 22.8,
    width: 50.4,
    height: 50.4,
    rx: 8.4,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 294.198,
    y: 22.8,
    width: 50.4,
    height: 50.4,
    rx: 8.4,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.999,
    y: 22.8,
    width: 50.4,
    height: 50.4,
    rx: 8.4,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M378.494 32.4522C381.303 38.0695 386.799 49.0724 390.137 60.017C391.614 64.8574 390.585 68.0115 388.888 69.9631C387.086 72.0365 384.143 73.2 381.114 73.2H377.172H368.909C363.336 73.2 360.984 70.9166 359.854 68.9856C359.236 67.9288 358.914 66.8474 358.752 66.0138C358.672 65.6024 358.633 65.2672 358.615 65.0479C358.606 64.9388 358.602 64.86 358.6 64.8166C358.599 64.8008 358.599 64.7897 358.599 64.7838V64.7837V64.7794V64.7745V64.7692V64.7634V64.7571V64.7503V64.7431V64.7353V64.727V64.7183V64.709V64.6993V64.6891V64.6785V64.6557V64.6436V64.631V64.6045V64.5761V64.5458V64.5137V64.4797V64.444V64.4064V64.3671V64.326V64.3047V64.2831V64.2385V64.1921V64.144V64.0943V64.0428V63.9897V63.9625V63.9348V63.8784V63.8203V63.7606V63.6992V63.6363V63.6042V63.5718V63.5057V63.4381V63.3689V63.2982V63.2623V63.226V63.1522V63.0004V62.9615V62.9222V62.8826V62.8426V62.6792V62.5953V62.5529V62.5101V62.3355V62.2461V62.201V62.1554V61.9701V61.8755V61.8277V61.7796V61.5841V61.4844V61.4341V61.3835V61.1781V52.6881V35.3578C358.599 31.6874 358.665 28.6403 359.889 26.4225C360.796 24.7785 362.658 23.1012 367.525 22.8362C371.137 23.047 373.06 24.1528 374.364 25.4698C375.764 26.8844 376.637 28.6686 377.784 31.0117C378.008 31.47 378.243 31.9497 378.494 32.4522Z",
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 5.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3984,
    y: 98.4004,
    width: 498.4,
    height: 28,
    rx: 14,
    fill: "#F1E29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolineUp1);
export default __webpack_public_path__ + "static/media/gasoline-up1.0e9c16a87610ebc6a414ca773ddc54be.svg";
export { ForwardRef as ReactComponent };